// Windsurf generated file
import { use } from 'react'
import { FeatureFlagsContext } from './feature-flags-context-definition'

export const useFeatureFlags = () => {
  const context = use(FeatureFlagsContext)
  if (!context) {
    throw new Error(
      'useFeatureFlags must be used within a FeatureFlagsProvider'
    )
  }
  return context
}
